<template>
  <div>
    <!-- 主要内容 -->
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="showModal">
      新增
    </a-button>
    <a-table 
      :columns="columns" 
      :data-source="data" 
      :loading="loading"
      :pagination="pagination"
      :row-key="(record) => record.id"
      @change="handleTableChange">

      <template slot="pay_type" slot-scope="text, record">
        <span v-if="record.pay_type == '1'">美团</span>
        <span v-if="record.pay_type == '2'">抖音</span>
        <span v-if="record.pay_type == '3'">快手</span>
      </template>

      <template slot="tag" slot-scope="text, record">
        <span v-if="record.tag == 1">游戏币套餐</span>
        <span v-if="record.tag == 2">门票套餐</span>
      </template>
      
      <template slot="projectNameList" slot-scope="text, record">
        <span v-if="record.projectNameList && record.projectNameList.length > 0">
          {{ record.projectNameList.map(item => item.projectName).join(', ') }}
        </span>
        <span v-else></span>
      </template>

      <template slot="package_type" slot-scope="text, record">
        <span v-if="record.package_type == 1">
          普通套餐
        </span>
        <span v-else-if="record.package_type == 2">
          年卡套餐
        </span>
        <span v-else-if="record.package_type == 3">
          半年卡套餐
        </span>
        <span v-else-if="record.package_type == 4">
          季卡套餐
        </span>
        <span v-else-if="record.package_type == 5">
          月卡套餐
        </span>
        <span v-else></span>
      </template>
      
      <template slot="operation" slot-scope="text, record">
        <a
          @click="buttonEdit(record)"
          
        >
          {{ data.length>0? '编辑':'' }}
        </a>
        <a
          @click="buttonDelete(record)"
          
        >
          {{ data.length>0? '删除':'' }}
        </a>
      </template>
     
    </a-table>
    
    <!-- 模态框 -->
    <a-modal
      :title="title"
      v-model:visible="visible"
      :confirm-loading="confirmLoading"
      @ok="onSubmit"
      @cancel="resetFields"
      :width="800"
      :centered="true"
      :padding="10"
      :key="modelRef.id"
      :maskClosable="false"
      :keyboard="false"

    >
      <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item label="平台" v-bind="validateInfos.pay_type">
          <a-radio-group v-model:value="modelRef.pay_type" :disabled="edit">
            <a-radio value="1" name="type">美团</a-radio>
            <a-radio value="2" name="type">抖音</a-radio>
            <a-radio value="3" name="type">快手</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="核销类型" v-bind="validateInfos.tag" >
          <a-radio-group v-model:value="modelRef.tag">
            <a-radio :value=1 name="type">游戏币</a-radio>
            <a-radio :value=2 name="type">门票</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="套餐类型" v-bind="validateInfos.package_type" v-if="modelRef.tag == 2">
           <a-radio-group v-model:value="modelRef.package_type">
            <a-radio value="1" name="type">普通套餐</a-radio>
            <a-radio value="2" name="type">年卡套餐</a-radio>
            <a-radio value="3" name="type">半年卡套餐</a-radio>
            <a-radio value="4" name="type">季卡套餐</a-radio>
            <a-radio value="5" name="type">月卡套餐</a-radio>
          </a-radio-group>
        </a-form-item>
         <a-form-item label="商品id" v-bind="validateInfos.project_code">
          <a-input v-model:value="modelRef.project_code" placeholder=""/>
        </a-form-item>
         <a-form-item label="商品名称" v-bind="validateInfos.goodName">
          <a-input v-model:value="modelRef.goodName" placeholder=""/>
        </a-form-item>
         <a-form-item label="商品券价" v-bind="validateInfos.amount">
          <a-input v-model:value="modelRef.amount" placeholder="系统记账价格"/>
        </a-form-item>
         <a-form-item label="核销币数" v-bind="validateInfos.coins">
          <a-input v-model:value="modelRef.coins" placeholder=""/>
        </a-form-item>
         <a-form-item label="项目次数" v-bind="validateInfos.frequency" v-if="modelRef.tag == 2">
          <div style="display: flex;align-items: center;gap: 8px;">
            <a-input v-model:value="modelRef.frequency" placeholder=""/>
            <a-tooltip v-if="modelRef.tag == 2" title='如果选择年月季卡套餐的时候，次数填0'>
                <span style="font-size: 20px; color:#1890ff; cursor: pointer;">!</span>
            </a-tooltip>
          </div>
        </a-form-item>
         <a-form-item label="项目名称" v-if="modelRef.tag == 2">
          <div style="display: flex;align-items: center;gap: 8px;">
            <a-select
                mode="multiple"
                v-model:value="modelRef.projectNameList"
                style="flex: 1;"
                placeholder="请选择项目"
                @change="handleChanges2"
              >
                <a-select-option
                  :value="item.objId"
                  v-for="(item, index) in cardTypeOptions2"
                  :key="index"
                >{{ item.projectName }}
                </a-select-option
                >
              </a-select>
              <a-tooltip v-if="modelRef.tag == 2" title='如果选择多个项目，充值的将是套票套餐，比如选择"淘气堡"，"沙池"，设置2次，会员得到是的两个项目各2次次数'>
                <span style="font-size: 20px; color:#1890ff; cursor: pointer;">!</span>
              </a-tooltip>
            </div>
          </a-form-item >
         <a-form-item label="项目次数有效期" v-bind="validateInfos.frequency_time" v-if="modelRef.tag == 2">
          <a-input v-model:value="modelRef.frequency_time" placeholder="按天数输入，会员以充值当天开始计起"/>
        </a-form-item>
         
       
        <a-form-item label="禁卡类型">
            <a-select
              mode="multiple"
              v-model:value="modelRef.disableCardNameList"
              style="width: 100%"
              placeholder="请选择会员卡类型"
              @change="handleChanges"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, index) in cardTypeOptions"
                :key="index"
              >{{ item.cardTypeName }}
              </a-select-option
              >
            </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { storeGetThirdParms,storeSetThirdParms,storeUpdateThirdParms,storeDeleteThirdParms,storeInfoCardType,storeClassification } from "@/api/storeApi.js";
import { message } from "ant-design-vue";


const columns = [
    {
    title: "id编号",
    dataIndex: "id",
    key: "1",
    align: "center",
    width:100,
    scopedSlots: { customRender: "id" },
  },
  {
    title: "平台",
    dataIndex: "pay_type",
    key: "2",
    align: "center",
    width:100,
    scopedSlots: { customRender: "pay_type" },
  },
    {
    title: "核销类型",
    dataIndex: "tag",
    align: "center",
    key: "3",
    width:100,
    scopedSlots: { customRender: "tag" },
  
  },
   {
    title: "商品id",
    dataIndex: "project_code",
    key: "4",
    align: "center",
    width:200,
    scopedSlots: { customRender: "project_code" },
  },
   {
    title: "商品名称",
    dataIndex: "goodName",
    key: "9",
    align: "center",
    width:200,
    scopedSlots: { customRender: "goodName" },
  },
   
   {
    title: "商品券价",
    dataIndex: "amount",
    key: "6",
    align: "center",
    width:100,
    scopedSlots: { customRender: "amount" },
  },
   {
    title: "币数",
    dataIndex: "coins",
    key: "7",
    align: "center",
    width:100,
    scopedSlots: { customRender: "coins" },
  },
   {
    title: "次数",
    dataIndex: "frequency",
    key: "8",
    align: "center",
    width:100,
    scopedSlots: { customRender: "frequency" },
  },
  {
    title: "项目名称",
    dataIndex: "projectNameList",
    key: "5",
    align: "center",
    width:200,
    scopedSlots: { customRender: "projectNameList" },
  },
  
   {
    title: "项目有效期",
    dataIndex: "frequency_time",
    key: "10",
    align: "center",
    width: 150,
    scopedSlots: { customRender: "frequency_time" },
  },
   {
    title: "套餐类型",
    dataIndex: "package_type",
    key: "11",
    align: "center",
    width:150,
    scopedSlots: { customRender: "package_type" },
  },
  
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    key: "12",
    align:"center",
  },

];

export default {
  components: {
    
  },
  data() {
    return {
      data: [],
      disableCardName: [],
      loading: false,
      columns,
      visible: false,
      title: "新增",
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      modelRef: {
        pay_type: "",
        tag: null,
        project_code: '',
        amount: '',
        coins: '',
        frequency: '',
        goodName: '',
        frequency_time: null,
        package_type: '',
        disableCardNameList: [],
        projectNameList: [],
      },
      validateInfos: {
        pay_type: "",
        tag: null,
        project_code: '',
        amount: '',
        coins: '',
        frequency: '',
        goodName: '',
        frequency_time: null,
        package_type: '',
        disableCardNameList: [],
        playabilityId:[],
        playabilityId2:[],
        projectNameList:[],
      },
      cardTypeOptions: [],
      cardTypeOptions2: [],
      confirmLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        
      },
      edit: false,
      
    };
  },
  mounted() {
    this.getShop();
    this.get();
    this.getProjectName();
  },
  props: ["formInline"],
  methods: {
    handleChanges(value) {
      this.modelRef.disableCardNameList = value;
      console.log(this.modelRef.disableCardNameList, "会员卡类型");
    },

    handleChanges2(value) {
      this.modelRef.projectNameList = value;
      console.log(this.modelRef.projectNameList, "项目名称");
    },
    // 获取会员卡类型
    async get(){
      this.loading = true;
      const objId = sessionStorage.getItem("shopId");

      try {
        const res = await storeInfoCardType(objId);
        this.loading = false;
        if(res.success && res.code ==="0000" && res.data){
            this.cardTypeOptions = res.data; 
        }else if(res.code ==="9999"){
          message.error(res.info);
        }else{ 
          console.log("会员卡类型为空");
        }
        return Promise.resolve(); // 确保返回 Promise
      } catch (error) {
        this.loading = false;
        console.error('请求出错:', error);
        message.error('请求出错: ' + error.message);
        return Promise.reject(error); // 确保返回 Promise
      }
    },
    // 获取项目名称
    async getProjectName(){
      this.loading = true;
      
      try {
        const res = await storeClassification({
          limit: 10,
          page: 1,
        });
        this.loading = false;
        console.log("项目名称",res);
        if(res.code === 0 && res.data){
          this.cardTypeOptions2 = res.data;
        }else{
          console.log("项目名称为空");
        }
        return Promise.resolve(); // 确保返回 Promise
      } catch (error) {
        this.loading = false;
        console.error('请求出错:', error);
        message.error('请求出错: ' + error.message);
        return Promise.reject(error); // 确保返回 Promise
      }
    },
    
    topage(routerpath) {
      this.$router.push(routerpath);
    },


    // 查询
    search() {
      this.data = [];
      this.loading = true;
      const objId = sessionStorage.getItem("shopId");
      this.pagination.current = 1; //重置页码
      storeGetThirdParms(
        objId,
        this.formInline.payType,
        this.pagination.current,
        this.pagination.pageSize
      ).then((res) => {
        this.loading = false;
        if(res.success && res.data.data && res.data.data.length>0){
          this.data = res.data.data;  
          this.pagination.total = res.data.count;
          message.info('查询成功');
        }else{
          message.error("暂无数据");
        }
        console.log('请求成功，返回数据:', res);
      }).catch((error) => {
        this.loading = false;
        console.error('请求出错:', error);
        message.error('请求出错: ' + error.message);
      });
    },

    getShop(){
      this.data = [];
      this.loading = true;
      const objId = sessionStorage.getItem("shopId");
      storeGetThirdParms(
        objId,
        "",
        this.pagination.current,
        this.pagination.pageSize
      ).then((res) => {
        this.loading = false;
        if(res.success && res.data.data && res.data.data.length>0){
          this.data = res.data.data;  
          // this.pagination.current = res.data.pages;  
          this.pagination.total = res.data.count;
        }else{
          message.error('暂无数据');
        }
        console.log('请求成功，返回数据:', res);
      }).catch((error) => {
        this.loading = false;
        console.error('请求出错:', error);
        message.error('请求出错: ' + error.message);
      });

    },
    showModal() {
      this.visible = true;
      this.edit = false;
      this.modelRef = {
        pay_type: "",
        tag: null,
        project_code: '',
        amount: '',
        coins: '',
        frequency: '',
        goodName: '',
        package_type: '',
        disableCardNameList: [],
        projectNameList:[],
      };
      this.volidateInfos = {
        pay_type: "",
        tag: null,
        project_code: '',
        amount: '',
        coins: '',
        frequency: '',
        goodName: '',
        package_type: '',
        disableCardNameList: [],
        projectNameList:[],
      };
      // 清空已选择的禁卡类型
      this.validateInfos.playabilityId = [];
      this.validateInfos.playabilityId2 = [];
      this.disableCardNameList = [];
      this.projectNameList = [];
      console.log('清空已选择的禁卡类型:', this.disableCardNameList);
      console.log('清空已选择的项目名称:', this.projectNameList);


    },
    panduan(option){
      if(!option.project_code)
      {
        message.error('请填写商品id');
        return false;
      }
      if(option.tag === 2){
        if(option.frequency === "" || option.frequency === null || option.frequency === undefined){
          message.error('请填写次数');
          return false;
        }
        if(!option.projectNameList || option.projectNameList.length === 0){
          message.error('请选择项目名称');
          return false;
        }
        if(option.frequency_time === "" || option.frequency_time === null || option.frequency_time === undefined){
          message.error('请填写次数有效期');
          return false;
        }
        if(option.frequency_time < 0){
          message.error('请填写有效的次数有效期');
          return false;
        }
        if(!option.package_type){
          message.error('请选择套餐类型');
          return false;
        }
        
      }else if(option.tag === 1){
        if(option.coins === "" || option.coins === null || option.coins === undefined ){
          message.error('请填写币数');
          return false;
        }
        // 检查是否为有效数字
        if(isNaN(option.coins) || Number.isNaN(Number(option.coins))){
          message.error('请填写有效的币数');
          return false;
        }
        // 转换为数字并检查是否小于0
        const coinsValue = Number(option.coins);
        if(coinsValue < 0){
          message.error('请填写有效的币数');
          return false;
        }
  
  
      }else{
        message.error('请选择标签');
        return false;
      }
      
      // 所有验证通过
      return true;
    },
    
    onSubmit() {
      this.loading = true;
      if (!this.panduan(this.modelRef)) {
        this.loading = false;
        return;
      }
      console.log('提交表单:', this.modelRef);
      // 提交表单逻辑
      if(this.edit){ 
        // 修改
        console.log('修改:', this.modelRef);
        // 处理提交数据，只传递必要字段
        let submitData = {
          ...this.modelRef,
          disableCardNameList: this.modelRef.disableCardNameList.map(item => {
            const option = this.cardTypeOptions.find(option => option.id == item);
            return {
              id: item,
              cardTypeName: option ? option.cardTypeName : item
            };
          })
        };

          // 门票套餐，处理项目名称列表
          submitData.projectNameList = this.modelRef.projectNameList.map(item => {
            const option = this.cardTypeOptions2.find(option => option.objId == item);
            return {
              objId: item,
              projectName: option ? option.projectName : item
            };
          });
        
        storeUpdateThirdParms(submitData).then((res) => {
          this.loading = false;
          if(res.success){
            message.success(res.info);
            this.getShop(); // 重新获取数据确保页面更新
          }else{
            message.error(res.info);
          }
          console.log('请求成功，返回数据:', res);
        }).catch((error) => {
          this.loading = false;
          console.error('请求出错:', error);
        })
      }else{ 
        //新增
        console.log('新增:', this.modelRef);
        // 处理提交数据，只传递必要字段
        let submitData = {
          ...this.modelRef,
          disableCardNameList: this.modelRef.disableCardNameList.map(item => {
            const option = this.cardTypeOptions.find(option => option.id == item);
            return {
              id: item,
              cardTypeName: option ? option.cardTypeName : item
            };
          })
        };
        
          // 门票套餐，处理项目名称列表
          submitData.projectNameList = this.modelRef.projectNameList.map(item => {
            const option = this.cardTypeOptions2.find(option => option.objId == item);
            return {
              objId: item,
              projectName: option ? option.projectName : item
            };
          });
        
        storeSetThirdParms(submitData).then((res) => {
          this.loading = false;
          if(res.success){
            message.success(res.info);
            this.getShop(); // 重新获取数据确保页面更新
          }else{
            message.error(res.info);
          }
          console.log('请求成功，返回数据:', res);
        }).catch((error) => {
          this.loading = false;
          console.error('请求出错:', error);
        })
      }
      this.visible = false;
    },
    
    resetFields() {
      this.modelRef = {
        pay_type: "",
        tag: null,
        project_code: '',
        amount: '',
        coins: '',
        frequency: '',
        goodName: '',
        frequency_time: null,
        package_type: '',
        disableCardNameList: [],
        projectNameList: [],
      };
      // 重置数组
      this.disableCardNameList = [];
      this.projectNameList = [];
      this.cardTypeOptions = [];
      this.cardTypeOptions2 = [];
    },
    
    handleTableChange(pagination, filters, sorter) {
      console.log('表格变化:', pagination, filters, sorter);
      // 更新分页信息
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      // 重新获取数据
      this.getShop();
    },
    
    buttonEdit(record) {
      this.edit = true;
      console.log('编辑记录:', record);
      this.text = '编辑';
      this.modelRef = {
        ...record,
      };


      // 处理禁卡类型回显 
      if (record.disableCardNameList && Array.isArray(record.disableCardNameList)) {
        
        this.modelRef.disableCardNameList = record.disableCardNameList.map(item => item.id)
        
      } else {
        this.modelRef.disableCardNameList = [];
      }

      // 处理项目名称回显 
      if (record.projectNameList && Array.isArray(record.projectNameList)) {
        
        this.modelRef.projectNameList = record.projectNameList.map(item => item.objId)
      } else {
        this.modelRef.projectNameList = [];
      }
      
      this.visible = true;
      
    },
    buttonDelete(record) {
      console.log('删除记录:', record);
      this.$confirm({
        title: "确定要删除吗?",
        content: "当您点击确定按钮后，该记录将被删除",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {  
          this.loading = true;
          storeDeleteThirdParms(record.id,record.store).then((res) => { 
            this.loading = false;
            if(res.success){
              this.loading = false;
              message.success(res.info);
              this.getShop();
            }else{
              message.error(res.info);
            }
          }).catch((error) => {
            this.loading = false;
            console.error('请求出错:', error);
          })
        },
        onCancel() {
          console.log("点击了取消");
        }
      })
    },
  },
};
</script>

<style scoped>
.test {
  position: relative;
  left: 55px;
}

#components-table-demo-summary tfoot th,
#components-table-demo-summary tfoot td {
  background: #fafafa;
}
[data-theme='dark'] #components-table-demo-summary tfoot th,
[data-theme='dark'] #components-table-demo-summary tfoot td {
  background: #1d1d1d;
}
</style>


// WEBPACK FOOTER //
// src/views/thirdShopManagement/thirdParmsContent.vue